module.exports = __webpack_public_path__ + "static/media/srm-logo.b2437213.png";